/* global I18n */

import { useState } from "react";

const i18nOptions = {
  scope: "components.shift_report_form",
};

const MemberTypePropertyFilterSelect = ({
  onChange,
  onRemove,
  attributes,
  memberTypeProperties,
}) => {
  const [selectedId, setSelectedId] = useState(attributes.memberTypePropertyId);
  const [filterValue, setFilterValue] = useState(attributes.value);

  const getDefaultFilterValueForMemberTypeProperty = (memberTypeProperty) => {
    switch (memberTypeProperty.type) {
      case "MemberTypeProperties::CustomCheckbox":
        return "t";
      case "MemberTypeProperties::CustomSelect":
        return Object.keys(memberTypeProperty.data.options)[0];
      default:
        return null;
    }
  };

  const getSelectedMemberTypeProperty = (id) => {
    return memberTypeProperties.find(
      (memberTypeProperty) => memberTypeProperty.id === id
    );
  };

  const propegateOnChange = (newAttributes) => {
    const updatedAttributes = { selectedId, filterValue, ...newAttributes };

    // Update local state
    if (newAttributes.selectedId !== undefined) {
      setSelectedId(newAttributes.selectedId);
    }
    if (newAttributes.filterValue !== undefined) {
      setFilterValue(newAttributes.filterValue);
    }

    // Propagate to parent
    onChange(attributes.key, updatedAttributes);
  };

  const handleSelectMemberTypeProperty = (event) => {
    const newSelectedId = parseInt(event.target.value);

    if (newSelectedId) {
      const selectedMemberTypeProperty =
        getSelectedMemberTypeProperty(newSelectedId);

      propegateOnChange({
        filterValue: getDefaultFilterValueForMemberTypeProperty(
          selectedMemberTypeProperty
        ),
        selectedId: newSelectedId,
      });
    } else {
      propegateOnChange({
        selectedId: null,
        filterValue: null,
      });
    }
  };

  const handleChangeFilterValue = (event) => {
    propegateOnChange({
      filterValue: event.target.value || null,
    });
  };

  const handleOnRemove = (e) => {
    e.preventDefault();
    onRemove(attributes.key);
  };

  const renderFilterableMemberTypePropertyOptions = () => {
    return memberTypeProperties.map((memberTypeProperty) => (
      <option key={memberTypeProperty.id} value={memberTypeProperty.id}>
        {memberTypeProperty.name}
      </option>
    ));
  };

  const renderFilter = () => {
    const selectedMemberTypeProperty =
      getSelectedMemberTypeProperty(selectedId);
    let type;
    if (selectedMemberTypeProperty != null) {
      type = selectedMemberTypeProperty.type;
    }

    switch (type) {
      case "MemberTypeProperties::CustomCheckbox":
        return (
          <select
            name={`report[member_type_properties][${selectedId}][]`}
            value={filterValue}
            className="form-control input-sm"
            style={{ width: "auto", display: "inline-block" }}
            onChange={handleChangeFilterValue}
          >
            <option value="t">{I18n.t("shared.yes")}</option>
            <option value="f">{I18n.t("shared.no")}</option>
          </select>
        );
      case "MemberTypeProperties::CustomSelect":
        return (
          <select
            name={`report[member_type_properties][${selectedId}][]`}
            value={filterValue}
            className="form-control input-sm"
            style={{ width: "auto", display: "inline-block" }}
            onChange={handleChangeFilterValue}
          >
            {Object.entries(selectedMemberTypeProperty.data.options).map(
              (option) => {
                const index = option[0];
                const value = option[1];
                return (
                  <option key={index} value={index}>
                    {value[I18n.currentLocale()]}
                  </option>
                );
              }
            )}
          </select>
        );
      default:
        return <span />;
    }
  };

  return (
    <div>
      <p>
        <button
          className="btn btn-warning pull-right"
          type="button"
          onClick={handleOnRemove}
        >
          {I18n.t("helpers.remove")}
        </button>
      </p>
      <p>
        <select
          className="form-control input-sm"
          style={{ width: "auto", display: "inline-block" }}
          value={selectedId || ""}
          onChange={handleSelectMemberTypeProperty}
        >
          <option value="">
            {I18n.t("choose_member_type_property", i18nOptions)}
          </option>
          {renderFilterableMemberTypePropertyOptions()}
        </select>
        {renderFilter()}
      </p>
    </div>
  );
};

export default MemberTypePropertyFilterSelect;
